import React, { FC, useState } from 'react';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Box,
  Button,
} from '@mui/material';
import { LocationAdminDetail } from 'src/api/Api';
import ConfirmationDialog from 'src/view/components/ConfirmationDialog';
import clientService from 'src/clientService';

interface LocationDetailsProps {
  location: LocationAdminDetail;
  deploymentCount: number;
  onLocationDeleted: (locationId: string) => void;
}

const LocationDetails: FC<LocationDetailsProps> = ({ location, deploymentCount, onLocationDeleted }) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleDelete = async () => {
    try {
      await clientService.api.deleteApiLocationApiV1AdminLocationsLocationIdDelete(location.location_id);
      onLocationDeleted(location.location_id);
    } catch (error) {
      console.error('Failed to delete location', error);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" component="h2" fontWeight="bold">
              Location Details
            </Typography>
            <Button variant="contained" color="error" onClick={() => setOpenConfirmDialog(true)}>
              Delete
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography color="text.secondary" variant="body2">Selected Location</Typography>
              <Typography variant="body1">{location.location_name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography color="text.secondary" variant="body2">Deployments</Typography>
                <Typography variant="body1">{deploymentCount}</Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <ConfirmationDialog
        open={openConfirmDialog}
        onCancel={() => setOpenConfirmDialog(false)}
        onConfirm={handleDelete}
        title="Delete Location"
        content="Are you sure you want to delete this location? This action will also delete all associated deployments, files, and data."
      />
    </>
  );
};

export default LocationDetails;
